import { useEffect, useState } from 'react'
import { isReactNativeApp } from '@mobi/web-native-comms/web'

export function useGeoLocationPermission() {
  const [permission, setPermission] = useState<string>()

  useEffect(() => {
    if (isReactNativeApp) return

    async function getPermission() {
      // get initial state
      const permission = await navigator.permissions.query({ name: 'geolocation' })
      setPermission(permission.state)

      // monitor for changes
      permission.onchange = () => setPermission(permission.state)
    }

    getPermission()
  }, [])

  return permission
}
